/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@keyframes appear{0%{top:300px;opacity:0}80%{top:-10px;opacity:1}100%{top:0;opacity:1}}@keyframes opened{0%{transform:rotate(0)}100%{transform:rotate(-180deg)}}@keyframes closed{0%{transform:rotate(180deg)}100%{transform:rotate(0)}}\n/*# sourceMappingURL=animations.css.map*/"];
export { styles as styles };
